import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { PlanungsgeschaeftCollection } from '@/models/Planungsgeschaeft';

/**
 * Creates a reactive connection between a PlanungsgeschaeftCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */
export function useGeschaefteCollection(options: UseCollectionOptions = {}) {
    const geschaefte = new PlanungsgeschaeftCollection();
    const initialFilters: ApiFilter[] = [];
    const refs = useCollection(geschaefte, {
        ...{
            tableSort: [],
            collectionsFilter: initialFilters,
            pageSize: 5
        },
        ...options
    });
    return refs;
}
